export default __webpack_public_path__ + "static/media/single-education-header-example.30a1cc00.png";